import React, { createContext, useContext, useState, useCallback } from "react";
import { translations } from "../mock";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("rapidpay_lang") || "es");

  const changeLang = useCallback((newLang) => {
    setLang(newLang);
    localStorage.setItem("rapidpay_lang", newLang);
  }, []);

  const t = translations[lang] || translations.es;

  return (
    <LanguageContext.Provider value={{ lang, changeLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
